<style lang="scss" scoped>
h2 {
    word-break: break-word;
    hyphens: auto;
}
</style>

<template>
    <div class="container mh-lg-100-vh">
        <div class="row">
            <div class="col-12 col-lg-5 col-xl-6 data-fixed-side d-none d-lg-block">
                <h2 class="mb-40" v-html="copyConfig.order_form.title"></h2>
                <el-orders v-model="abstractOrders" class="mr-xl-24"></el-orders>
            </div>
            <div class="col-12 col-lg-7 col-xl-6">
                <el-orders-form class="ml-xl-24 p-0 p-lg-40 mb-40" :orders="orders" :copy-config="copyConfig"></el-orders-form>
            </div>
        </div>
    </div>
</template>

<script>
import abstractOrders from "../mixins/abstract-orders";

export default {
    name: "pageParts.order-form",

    mixins: [abstractOrders],

    props: {
        orders: {
            type: Object,
            default: function() {
                return {
                    activities: [],
                    speakers: [],
                    locations: [],
                    staticItems: [],
                    gifts: []
                }
            }
        },
        copyConfig: {
            type: Object,
            required: true,
        },
    },
}
</script>